import React from 'react';

import {
    Center, Tooltip,
} from '@mantine/core';

export default function useColPocketTypeSchema() {
    const colPocketTypeSchema = {
        accessor: 'entity.type',
        title: 'Тип',
        style: {
            maxWidth: 40,
            minWidth: 40,
            width: 40,
        },
        render: ({ currentData }) => (
            <Tooltip label={currentData}>
                <Center>
                    {currentData?.slice(0, 1)}
                </Center>
            </Tooltip>
        ),
    };

    return colPocketTypeSchema;
}
